<template>
  <header>
    <div class="container flexBox">
      <div class="left">
        <router-link to="/">
          <img class="logo" src="../assets/logo.png"/>
        </router-link>
      </div>
      <div class="right">
        <a href="#" @click="signOut" v-if="user">ログアウト</a>
        <!--<router-link to="/sign"  v-if="!user">ログイン</router-link>-->
      </div>
    </div>
  </header>
</template>

<script>
import firebase from 'firebase/app'

export default {
  name: 'Header',
  components: {
  },
  created: function () {
    firebase.auth().onAuthStateChanged(user => {
      this.user = user
    })
  },
  data () {
    return {
      user: undefined
    }
  },
  methods: {
    signOut: function () {
      firebase.auth().signOut().then(() => {
        this.$router.push('/')
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .flexBox{
    display: flex;
    justify-content: space-between;
  }
  header{
    height: 80px;
  }
  .right{
    font-size: 20px;
    line-height: 50px;
    padding-top: 15px;
  }
  .right a{
    display: block;
    padding: 0 10px;
    color: #000;
    text-decoration: none;
  }
  .right a:hover{
    background: rgba(255,255,255,0.2);
  }
  .container{
    padding: 0;
  }
  .logo{
    margin-top: 14px;
    width: 206px;
  }
  @media all and (max-width: 480px) {
    .right{
      font-size: 14px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue